"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('audit', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M7.99969 36L8.0043 28.0426C8.0052 27.4906 8.45283 27.0432 9.00488 27.0426C12.3389 27.0426 15.6728 27.0426 19.0068 27.0426C19.9283 27.0426 19.9234 26.2252 19.9234 24.2792C19.9234 22.3332 15.0218 20.6941 15.0218 13.8528C15.0218 7.01151 20.0996 5 24.3197 5C28.5398 5 33.1363 7.01151 33.1363 13.8528C33.1363 20.6941 28.2605 21.7818 28.2605 24.2792C28.2605 26.7765 28.2605 27.0426 29.041 27.0426C32.3607 27.0426 35.6803 27.0426 39 27.0426C39.5523 27.0426 40 27.4904 40 28.0426V36H7.99969Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M8 42H40",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;